
import { Options, Vue } from 'vue-class-component';
import EventBusService from "@/services/EventBusService";
import { UserCreditHasTrialEvent } from "@/data/eventbus";
import { RegionLinkable } from "@/data/region";
import Alert from "@/components/Alert.vue";

@Options({
    props: {

    },
    methods: {

    },
    components: {
        Alert,
    },
})
export default class UnusedTrialCreditAlert extends Vue {
    hasTrial = false

    regionLinkable: RegionLinkable|null = null

    get regionDetailLinkUrl() {
        if( !this.regionLinkable ) {
            return '#';
        }
        return this.$navigation.buildRouteUrl('region', {slug: this.regionLinkable.slug});
    }

    onHasTrialCreditsChanged(event: UserCreditHasTrialEvent) {
        this.hasTrial = event.hasTrial;
        this.regionLinkable = event.regionLinkable;
    }

    mounted() {
        EventBusService.$on('user.credits.hasTrial:changed', this.onHasTrialCreditsChanged);
    }

    beforeUnmount() {
        EventBusService.$off('user.credits.hasTrial:changed', this.onHasTrialCreditsChanged);
    }
}
